export const planData = [
    {
        hour: 0,
        orderNum: ""
    },
    {
        hour: 1,
        orderNum: ""
    },
    {
        hour: 2,
        orderNum: ""
    },
    {
        hour: 3,
        orderNum: ""
    },
    {
        hour: 4,
        orderNum: ""
    },
    {
        hour: 5,
        orderNum: ""
    },
    {
        hour: 6,
        orderNum: ""
    },
    {
        hour: 7,
        orderNum: ""
    },
    {
        hour: 8,
        orderNum: ""
    },
    {
        hour: 9,
        orderNum: ""
    },
    {
        hour: 10,
        orderNum: ""
    },
    {
        hour: 11,
        orderNum: ""
    },
    {
        hour: 12,
        orderNum: ""
    },
    {
        hour: 13,
        orderNum: ""
    },
    {
        hour: 14,
        orderNum: ""
    },
    {
        hour: 15,
        orderNum: ""
    },
    {
        hour: 16,
        orderNum: ""
    },
    {
        hour: 17,
        orderNum: ""
    },
    {
        hour: 18,
        orderNum: ""
    },
    {
        hour: 19,
        orderNum: ""
    },
    {
        hour: 20,
        orderNum: ""
    },
    {
        hour: 21,
        orderNum: ""
    },
    {
        hour: 22,
        orderNum: ""
    },
    {
        hour: 23,
        orderNum: ""
    }
];
